import React from 'react';
import Skeleton from "react-loading-skeleton";
import '../Css/homeSkeleton.css';

const ChercheRapideSkeleton = () => {
  return (
    <div className='homeSkeleton'>

      <div className='mainHomeSkeleton'>
        <div className='restaurantSkeleton'>

          <div className='row'>

            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>
            <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4'>
              <div className='cardSkeleton'>
                <Skeleton height="48px" width="100%" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ChercheRapideSkeleton;